






















import VueOptions from '@utils/VueOptions'
import VenueNavbar from '@ui/VenueWizard/VenueNavbar'
import WizardNavigation from '@ui/VenueWizard/WizardNavigation'
import VenueCard from '@ui/cards/VenueCard'
import VenueDisplay from '@ui/Venue/VenueDisplay'

settings =
  name: 'VenuePreviewStep'

  vue:
    props: ['wizard', 'step']

    components: {
      VenueNavbar,
      WizardNavigation,
      VenueCard,
      VenueDisplay,
    }

    mounted: ->
      @wizard.fetchVenue()

export default VueOptions.vue settings
